<script setup lang="ts">
import { t } from '@/i18n';
import { onMounted,onUnmounted } from 'vue';
import { useRoute,useRouter } from 'vue-router';
import AppShell from '@/components/AppShell.vue';
import ToastHost from '@/components/ToastHost.vue';
import { useAuthStore } from '@/stores/auth';
import { useToast } from '@/composables/useToast';
import { navigationPending } from '@/router';
const route=useRoute(),router=useRouter(),auth=useAuthStore(),toast=useToast();
let redirecting=false;
function expired(){if(route.meta.public||redirecting)return;redirecting=true;auth.user=null;toast.info(t('common.expired'));void router.replace({path:'/login',query:{next:route.fullPath}}).finally(()=>{redirecting=false;});}
onMounted(()=>window.addEventListener('session-expired',expired));onUnmounted(()=>window.removeEventListener('session-expired',expired));
</script>
<template>
  <div v-if="navigationPending" class="navigation-progress" role="status" :aria-label="t('common.loadingPage')"/>
  <RouterView v-if="route.meta.public" :key="route.path"/>
  <AppShell v-else>
    <RouterView v-slot="{Component}">
      <Transition name="page" mode="out-in">
        <div :key="route.path" class="route-content"><component :is="Component"/></div>
      </Transition>
    </RouterView>
  </AppShell>
  <ToastHost/>
</template>
